var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:[_vm.badgeConfig.chipClass, 'font-weight-bold elevation-0 border-chip'],attrs:{"small":_vm.small,"x-small":_vm.xSmall}},[(_vm.showIcon)?_c('v-icon',{attrs:{"left":"","small":"","color":_vm.badgeConfig.iconColor}},[_vm._v(" "+_vm._s(_vm.badgeConfig.icon)+" ")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.badgeConfig.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }